import type Guid from "@/app/types/common/guid";
import { EnumSalesVisitAssociatedEntityType } from "@/app/services/generated/enums/enumSalesVisitAssociatedEntityType.generated";
import { showModalDialog } from "@/components/platform/common/showModalDialog";
import type { PlannedSalesVisit } from "@/app/services/generated/salesvisitService";
import { salesVisitService } from "@/app/services/generated/salesvisitService";
import CreateOrEditSalesVisitDialog from "@/components/pages/orders/salesvisits/components/CreateOrEditSalesVisitDialog.vue";
import userStore from "@/store/modules/userStore";
import { newPlannedSalesVisit } from "@/components/pages/orders/salesvisits/useSalesVisitData";

export async function showCreateSalesVisitDialog(opts: {
  entityType: "outlet" | "lead" | "group";
  entityId?: Guid;
}) {
  const typeEnum =
    opts.entityType === "lead"
      ? EnumSalesVisitAssociatedEntityType.lead
      : opts.entityType === "group"
        ? EnumSalesVisitAssociatedEntityType.group
        : EnumSalesVisitAssociatedEntityType.outlet;

  const salesVisit = newPlannedSalesVisit({
    userId: userStore.state.user?.id,
    associatedEntityType: typeEnum,
    associatedEntityId: opts.entityId,
  });

  const { value, wasSuccessful } = await showModalDialog<
    PlannedSalesVisit,
    typeof CreateOrEditSalesVisitDialog
  >(CreateOrEditSalesVisitDialog, {
    props: {
      salesVisit,
    },
  });

  if (value && wasSuccessful) {
    await salesVisitService.savePlannedSalesVisit(value);
  }

  return { value, wasSuccessful };
}
